import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/resources/home-market-approval-eu-readiness")({
  head: () => buildRouteHead("/en/resources/home-market-approval-eu-readiness", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ href: "/en/downloads/home-market-approval-eu-readiness", replace: true });
  },
});
